// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Help {\n  padding: 1rem;\n  line-height: 150%;\n}\n\n.Help img {\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n  width: 90%;\n}\n\n.Help iframe {\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n  width: 85%;\n  padding: 1rem;\n}\n", ""]);
// Exports
module.exports = exports;
